import {
  COMMUNITY_ACTION_STARTS,
  COMMUNITY_ACTION_ERRORS,
  GET_ALL_COMMUNITIES,
  GET_COMMUNITY_BY_ID,
  GET_MY_COMMUNITIES,
  CREATE_COMMUNITY,
  UPDATE_COMMUNITY,
  DELETE_COMMUNITY,
  TRANSFER_OWNERSHIP,
  JOIN_COMMUNITY,
  LEAVE_COMMUNITY,
} from './actions';

const initialState = {
  communities: [],
  myCommunities: [],
  currentCommunity: null,
  loading: false,
  error: null,
};

const communityReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case COMMUNITY_ACTION_STARTS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case COMMUNITY_ACTION_ERRORS:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case GET_ALL_COMMUNITIES:
      return {
        ...state,
        loading: false,
        communities: action.payload,
        error: null,
      };
    case GET_COMMUNITY_BY_ID:
      return {
        ...state,
        loading: false,
        currentCommunity: action.payload,
        error: null,
      };
    case GET_MY_COMMUNITIES:
      return {
        ...state,
        loading: false,
        myCommunities: action.payload,
        error: null,
      };
    case CREATE_COMMUNITY:
      return {
        ...state,
        loading: false,
        communities: [action.payload, ...state.communities],
        error: null,
      };
    case UPDATE_COMMUNITY:
      return {
        ...state,
        loading: false,
        communities: state.communities.map((community: any) =>
          community.id === action.payload.id ? action.payload : community
        ),
        currentCommunity: action.payload,
        error: null,
      };
    case DELETE_COMMUNITY:
      return {
        ...state,
        loading: false,
        communities: state.communities.filter((community: any) => community.id !== action.payload),
        error: null,
      };
    case TRANSFER_OWNERSHIP:
      return {
        ...state,
        loading: false,
        communities: state.communities.map((community: any) =>
          community.id === action.payload.communityId 
            ? { ...community, owner_id: action.payload.newOwnerId }
            : community
        ),
        error: null,
      };
    case JOIN_COMMUNITY:
      return {
        ...state,
        loading: false,
        communities: state.communities.map((community: any) =>
          community.id === action.payload 
            ? { ...community, is_member: true, member_count: (community.member_count || 0) + 1 }
            : community
        ),
        error: null,
      };
    case LEAVE_COMMUNITY:
      return {
        ...state,
        loading: false,
        communities: state.communities.map((community: any) =>
          community.id === action.payload 
            ? { ...community, is_member: false, member_count: Math.max((community.member_count || 1) - 1, 0) }
            : community
        ),
        error: null,
      };
    default:
      return state;
  }
};

export default communityReducer;
